import React from 'react';
import HomeIntro from '@/components/HomeIntro';

export default function HomeLoading({ title, tickerItems }) {
  return (
    <div className="min-h-screen flex flex-col bg-background" aria-busy="true">
      <div className="h-16 md:h-20 border-b border-border shrink-0" aria-hidden="true" />
      <main className="flex-1">
        <HomeIntro title={title} tickerItems={tickerItems} />
        <div className="min-h-[900px] md:min-h-[500px]" aria-hidden="true" />
      </main>
    </div>
  );
}